import Settings from '../config.js';
import Auth from '../services/Auth.js';

let serialize = (obj) => {
  var str = [];
  for (var p in obj) {
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  }

  return str.join("&");
};

var API = {
  call: (method, endpoint, payload, callback) => {
    endpoint = (endpoint.indexOf('http') == -1 ? Settings.V1_API_URL.replace(/\/$/, "") : '') + endpoint;
    endpoint += (endpoint.indexOf('?') == -1 ? '?' : '&') + 't=' + (new Date()).getTime();

    // make sure there's always an access_token param, and header
    let authorization = '';
    if (endpoint.indexOf(Settings.V1_API_URL) != -1) {
      if (endpoint.indexOf('access_token=') === -1) {
        endpoint += '&access_token=' + Auth.getToken(); // not always needed, but adding it won't hurt
      }
    }
    authorization = Auth.getToken() ? ('Bearer ' + Auth.getToken()) : '';

    switch (String(method).toUpperCase()) {
      case 'GET':
        endpoint += (endpoint.indexOf('?') == -1 ? '?' : '&') + serialize(payload);

        return fetch(endpoint, {
          headers: new Headers({
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            'Authorization': authorization,
          }),
        })
        .then(res => res.json())
        .then(
          (result) => {
            return callback(result, null);
          },
          (error) => { // Note: it's important to handle errors here instead of a catch() block so that we don't swallow exceptions from actual bugs in components.
            return callback(null, error);
          }
        );
        break;
      case 'POST':
        payload = typeof payload == 'string' ? payload : JSON.stringify(payload);

        return fetch(endpoint, {
          method: String(method).toUpperCase(),
          headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            'Authorization': authorization,
          },
          body: payload
        })
        .then(res => res.json())
        .then(
          (result) => {
            return callback(result, null);
          },
          (error) => { // Note: it's important to handle errors here instead of a catch() block so that we don't swallow exceptions from actual bugs in components.
            return callback(null, error);
          }
        );
        break;
      case 'PUT':
        // payload = JSON.stringify(payload);

        var url = endpoint;
        var data = payload;
        var json = JSON.stringify(data);

        var xhr = new XMLHttpRequest();
        xhr.open("PUT", endpoint, true);

        xhr.setRequestHeader('Accept', 'application/json, text/plain, */*');
        xhr.setRequestHeader('Content-type', 'application/json');
        xhr.setRequestHeader('Authorization', authorization);

        xhr.onload = function () {
          var result = JSON.parse(xhr.responseText);

          if (xhr.readyState == 4 && parseInt(xhr.status) >= 200 && parseInt(xhr.status) < 300) {
            return callback(result, null);
          } else {
            return callback(null, result);
          }
        }

        xhr.send(json);
        break;
      default:
        console.error('API method ' + method + ' not supported. Sorry');

        return false;
    }
  }
}

export default API;


// WEBPACK FOOTER //
// ./src/utils/API.js